"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const assetsGlobals_1 = require("../assetsGlobals");
const sceneHelper_1 = require("./sceneHelper");
const dialogBox_1 = require("../dialogBox");
class LoadingScene extends Phaser.Scene {
    constructor() {
        super({
            key: "LoadingScene"
        });
    }
    init(data) {
        console.log('init', data);
        this._sceneData = data;
        console.log(this._sceneData.getKey());
    }
    preload() {
        this.load.json(this._sceneData.getKey(), './assets/sceneDescriptions/' + this._sceneData.getKey() + '.json');
        this.load.image(assetsGlobals_1.AssetGlobals.BG_IMAGE_LOADING, "./assets/backgrounds/" + assetsGlobals_1.AssetGlobals.BG_IMAGE_LOADING + ".jpg");
    }
    create() {
        this.add.image(this.game.renderer.width / 2, this.game.renderer.height / 2, assetsGlobals_1.AssetGlobals.BG_IMAGE_LOADING);
        console.log(this._sceneData);
        sceneHelper_1.SceneHelper.switchToMainScreen(this.scene.manager, this._sceneData);
    }
    renderActionText(text) {
        if (this.dbox) {
            this.dbox.toggleWindow();
        }
        this.dbox = new dialogBox_1.DialogBox(this);
        this.dbox._createWindow();
        this.dbox.setText(text, false);
    }
}
exports.LoadingScene = LoadingScene;
